module.exports = __webpack_public_path__ + "img/VIP.35cbd298.svg";